import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from "../../../redux/hook";
import { getPromotion, isObjectNotNull } from "../../../utils";
import Loyalty from "../../Loyalty";
import OrderTotal from "../../Order/components/OrderTotal";
import OrderCart from "../../Order/components/OrderCart.view";
import getStyles from "../Order.styles";
import {
  analyticsEvents,
  PAGES,
  PROVENANCE,
} from '../../../utils/firebaseAnalytics';
import { verifyPendingOrderValidity } from '../../../Pages/Home/Home.services';
import { updateUserLoyaltyPoints } from '../../../redux/actions';

type CartProps = {
  order: any;
  showPromo: boolean;
  deleteOption: boolean;
};

export default function Cart({ order, showPromo, deleteOption }: CartProps) {
  const { userConnected, isUserAnonymous, user } = useAppSelector(
    (state) => state.userReducer
  );
  const [isLoading, setIsLoading] = useState(false);
  const pendingOrder = useAppSelector((state) => state.pendingOrderReducer);
  const {
    totalProductPriceOrder: totalProductPrice,
    marketingCampaignPromoAmount,
    totalPriceOrder,
    managementFee,
  } = pendingOrder;
  const { commande } = order;
  const showReduction = (userConnected || isUserAnonymous) && showPromo;
  const isPendingOrder = !commande;
  const dispatch = useAppDispatch();

  useEffect(() => {
    updateUserLoyaltyPoints(
      user.customerId,
      isUserAnonymous,
      dispatch,
    );
  }, [isUserAnonymous, user?.customerId]);

  useEffect(() => {
    analyticsEvents.logPageViewEvent(PAGES.CART, PROVENANCE.MENU_PAGE);
    (async () => {
      if (!order?.chargeId) {
        setIsLoading(true);
        await verifyPendingOrderValidity();
        setIsLoading(false);
      }
    })();
  }, []);
  const styles = getStyles()
  return isObjectNotNull(order) ? (
    <div>
      <OrderCart
        commande={commande}
        deleteOption={deleteOption}
        styles={styles}
        title="Panier"
      />
      {showReduction && !isUserAnonymous && (
        <div>
          <Loyalty totalProductPrice={totalProductPrice} />
        </div>
      )}
      {showReduction && <hr className="my-1 hr" />}
      {showPromo &&
        <OrderTotal
          commande={commande}
          promotion={
            isPendingOrder ? getPromotion(totalProductPrice) : order.promotion
          }
          showFees
          isOrderFreeDelivery={order.freeDelivery}
          marketingCampaignPromoAmount={
            isPendingOrder
              ? marketingCampaignPromoAmount
              : order.marketingCampaignPromoAmount
          }
          totalPriceOrder={
            isPendingOrder ? totalPriceOrder : order.totalPriceOrder
          }
          managementFee={isPendingOrder ? managementFee : order.managementFee}
          totalProductPriceOrder={
            isPendingOrder ? totalProductPrice : order.totalProductPriceOrder
          }
          isPast={true}
        />
      }
    </div>
  ) : null;
}